import script from "./conferencePage.vue?vue&type=script&setup=true&lang=js"
export * from "./conferencePage.vue?vue&type=script&setup=true&lang=js"

import "./conferencePage.vue?vue&type=style&index=0&id=118b2e98&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-118b2e98"]])

export default __exports__